import useReveal from "../../hooks/useReveal";

const steps = [
	{
		n: "01",
		title: "Start a match on your Watch",
		description:
			"Choose your sport and match format. Racketly applies the scoring rules while you stay focused on the first serve.",
		tag: "Set up in seconds",
	},
	{
		n: "02",
		title: "Tap who won the point",
		description:
			"One glance shows the score, sets and server. Log points from your wrist and undo a tap when the rally gets hectic.",
		tag: "Stay in the rally",
	},
	{
		n: "03",
		title: "Review the match, not just the score",
		description:
			"After the final point, see your match history and the details that make each session count.",
		tag: "Learn from every match",
	},
	{
		n: "04",
		title: "Keep every sport in one place",
		description:
			"From padel and tennis to pickleball, badminton, squash and ping pong, every match has a home in Racketly.",
		tag: "One app, every court",
	},
];

function Step({ step, index }) {
	const ref = useReveal(index);
	const isDark = step.isDark;
	return (
		<div
			ref={ref}
			className="reveal grid grid-cols-[auto_1fr] gap-6 md:gap-10 py-10"
			style={{ borderTop: `var(--rule-hair) solid ${isDark ? "var(--color-night-rule)" : "var(--color-rule-2)"}` }}
		>
			<span
				className="font-display font-bold"
				style={{
					fontSize: "var(--text-3xl)",
					color: "var(--color-accent)",
					letterSpacing: "var(--tracking-display)",
				}}
			>
				{step.n}
			</span>
			<div>
				<p
					className="font-display font-bold uppercase mb-2"
					style={{
						fontSize: "var(--text-xs)",
						letterSpacing: "var(--tracking-label)",
						color: isDark ? "var(--color-on-night-muted)" : "var(--color-muted)",
					}}
				>
					{step.tag}
				</p>
				<h3
					className="font-display font-bold"
					style={{
						fontSize: "var(--text-2xl)",
						color: isDark ? "var(--color-on-night)" : "var(--color-ink)",
					}}
				>
					{step.title}
				</h3>
				<p
					className="mt-3"
					style={{
						fontSize: "var(--text-md)",
						lineHeight: "var(--lh-body)",
						color: isDark ? "var(--color-on-night-muted)" : "var(--color-muted)",
						maxWidth: "var(--measure)",
					}}
				>
					{step.description}
				</p>
			</div>
		</div>
	);
}

const FeaturesSection = ({ isDark }) => {
	const headRef = useReveal(0);
	const surface = isDark ? "var(--color-night)" : "var(--color-paper)";
	const ink = isDark ? "var(--color-on-night)" : "var(--color-ink)";
	const muted = isDark ? "var(--color-on-night-muted)" : "var(--color-muted)";

	return (
		<section id="features" className="py-20 md:py-28" style={{ background: surface }}>
			<div className="container mx-auto px-4 sm:px-6 max-w-3xl">
				<div ref={headRef} className="reveal mb-4">
					<p
						className="font-display font-bold uppercase mb-3"
						style={{ fontSize: "var(--text-sm)", letterSpacing: "var(--tracking-label)", color: "var(--color-accent)" }}
					>
						How it works
					</p>
					<h2
						className="font-display font-bold uppercase"
						style={{
							fontSize: "var(--text-display-s)",
							lineHeight: "var(--lh-tight)",
							letterSpacing: "var(--tracking-display)",
							color: ink,
							overflowWrap: "anywhere",
						}}
					>
						From first serve to full match history
					</h2>
					<p className="mt-4" style={{ fontSize: "var(--text-lg)", color: muted, maxWidth: "var(--measure)" }}>
						Your watch handles the score. Your phone keeps the story of your game.
					</p>
				</div>

				{steps.map((step, index) => (
					<Step key={step.n} step={{ ...step, isDark }} index={index} />
				))}
			</div>
		</section>
	);
};

export default FeaturesSection;
